import { enforceNumeric } from './formatters';

export const US_PHONE_PATTERN = '\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}';

export function formatUSPhoneNumber(value: string) {
  const regexSearch = /([0-9]{1,3})?([0-9]{1,3})?([0-9]{1,4})?/;
  function formatter(_match: string, p1: string, p2: string, p3: string) {
    let formattedValue = '';

    if (p1 && !p2) {
      formattedValue = `${p1}`;
    }

    if (p1 && p2) {
      formattedValue = `(${p1})`;
    }

    if (p2) {
      formattedValue += ` ${p2}`;
    }

    if (p3) {
      formattedValue += `-${p3}`;
    }

    return formattedValue;
  }

  return enforceNumeric(value).replace(regexSearch, formatter);
}

/**
 * Applies the same formatting and pattern check as a `tel` TextField.
 * @returns the formatted number, or null if it does not match the pattern
 */
export function getFormattedUSPhoneNumber(value: string): string | null {
  const formatted = formatUSPhoneNumber(value);
  // HTML `pattern` implicitly matches the whole value; RegExp does not.
  return new RegExp(`^(?:${US_PHONE_PATTERN})$`).test(formatted)
    ? formatted
    : null;
}

export const phoneFormattersByRegion = {
  us: {
    props: {
      pattern: US_PHONE_PATTERN,
      maxLength: '(999) 999-9999'.length
    },
    format: formatUSPhoneNumber
  }
};
